import React from "react"

const Footer = () => {
    return (

        <p className="text-center fc-primary mt-30">&copy; 2024 Bobrick Washroom Equipment, Inc.</p>
    )
}

export default Footer